export default __webpack_public_path__ + "static/media/mob_phone.d967e171.svg";